export default __webpack_public_path__ + "static/media/virtual-number-example.f3552411.mp3";